export default __webpack_public_path__ + "static/media/accounting-screenshot.fb0841da.png";